import { createReducer } from 'redux-immutablejs'
import { getInitialState, buildHandlers } from 'redux/entities'
import {
  accountsActions,
  adminsActions,
  availabilitiesByDateActions,
  bankAccountsActions,
  bookingsActions,
  campaignsActions,
  categoriesActions,
  conversationsActions,
  eventsActions,
  filesActions,
  followupsActions,
  hostApplicationsActions,
  invitesActions,
  offlinereviewsActions,
  organizationsActions,
  partnersActions,
  partnerDemandsActions,
  payoutsActions,
  playlistsActions,
  pricingsActions,
  requestsActions,
  reviewsActions,
  searchEventsActions,
  schedulesActions,
  usersActions,

  // statics
  currenciesActions,
  languagesActions,
  tagsActions,
} from 'redux/entities/actions'

import additionalHandlers from './additionalHandlers'

const actionsCreators = {
  accountsActions,
  adminsActions,
  availabilitiesByDateActions,
  bankAccountsActions,
  bookingsActions,
  campaignsActions,
  categoriesActions,
  conversationsActions,
  currenciesActions,
  eventsActions,
  filesActions,
  followupsActions,
  hostApplicationsActions,
  invitesActions,
  languagesActions,
  offlinereviewsActions,
  organizationsActions,
  partnersActions,
  partnerDemandsActions,
  payoutsActions,
  playlistsActions,
  pricingsActions,
  requestsActions,
  reviewsActions,
  searchEventsActions,
  schedulesActions,
  tagsActions,
  usersActions,
}

const initialState = getInitialState({ options: { metadata: true } })
const handlers = buildHandlers({ actionsCreators, additionalHandlers })

export default createReducer(initialState, handlers)
